// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8fe3947","455":"7f915ac4","977":"73647da3"}[chunkId] + ".chunk.js";
};